{
  "Can i translate this ?": "Мога ли да преведа това ?",
  "Accounts": "Свързани акаунти",
  "Site settings": "Настройки на сайта",
  "Language": "Език",
  "Enable Marmaid": "Включи Marmaid",
  "Enable Blur": "Включи замагляване",
  "Enable Animations": "Включи анимаций",
  "Personal information": "Персонална информация",
  "NO": "Не",
  "YES": "Да",
  "General": "Генерални",
  "Profile": "Профил",
  "Notifications": "Нотификации",
  "Identity": "Идентичност",
  "Tokens": "Токени",
  "Instances": "Инстанции",
  "Domains": "Домейни",
  "Sessions": "Сесии",
  "My Sessions": "Мойте сесии",
  "No projects": "Няма проекти",
  "Create project": "Създай проект",
  "Projects": "Проекти",
  "Project name": "Име на проекта",
  "Project description": "Описание на проекта",
  "Select team": "Избери екип",
  "Set unique description for project": "Добави уникално описание към проекта",
  "Please fill out this field.": "Моля попълнете полето.",
  "Create": "Създай",
  "OwnedBy": "Създател",
  "Open": "Влез",
  "Settings": "Настройки",
  "Apps": "Апликации",
  "Logout": "Излез",
  "Admin": "Админ",
  "Iot": "Автоматика",
  "Name": "Име",
  "Email": "Имейл",
  "You have being mentioned inside": "Бяхте споменат тук",
  "from project": "към проект",
  "by": "от",
  "You have being invited as member inside project": "Бяхте поканени като член на проект",
  "to build awesome things": "да изграждате невероятни неща"
}